import React, { useContext } from 'react';
import {
  useEffect,
  useState,
} from 'react';
import {
  Outlet,
  useNavigate,
  // useSearchParams,
} from 'react-router-dom';

import { useAuth } from 'react-oidc-context';
import Cookies from 'universal-cookie';
import { SnackbarContext } from '../App';
import SessionExpiredModal from '../utils/SessionExpiredModal';

export default function ProtectedRoute(props) {
  const auth = useAuth();

  const navigate = useNavigate();

  const cookies = new Cookies();

  const currentPath = cookies.get('currentPath') || '/';

  const { sessionExpired } = useContext(SnackbarContext);
  // const [ authenticated, setAuthenticated ] = useState(false)

  // useEffect(() => {
  //     keycloak.init({onLoad: 'login-required'})
  // }).then(isAuthenticated => {
  //     setAuthenticated(isAuthenticated)
  //     console.log(isAuthenticated)
  // })

  // const navigate = useNavigate();
  // const [
  //     isLoggedIn,
  //     setIsLoggedIn,
  // ] = useState(false);
  // const checkUserToken = () => {
  //     // const userToken = localStorage.getItem('user-token');
  //     // let params = Object.fromEntries([...searchParams])
  //     let token = Cookies.get('IdToken')

  //     if (token){
  //         console.log('found token')
  //     }else{
  //         setIsLoggedIn(false);
  //         console.log('naviagte')
  //         return navigate('/auth/login');
  //     }
  //     setIsLoggedIn(true);
  // }

  // useEffect(() => {
  //     if(!auth.isAuthenticated){
  //         auth.signinSilent()
  //     }
  //     console.log(auth.isAuthenticated)
  // })

  useEffect(() => {
    console.log(auth.isAuthenticated);
    if (!auth.isAuthenticated) {
      navigate('/landing');
      auth.signinSilent();
    } else {
      if (!auth.user?.profile?.accountant || !auth.user?.profile?.accountant?.verified || !auth.user?.profile?.accountant?.ssid) {
        navigate('/setup');
      } else {
        if (currentPath.includes('/setup')) {
          navigate('/');
        }
      }
    }
  },
  [auth.isAuthenticated],
  );

  return (
    <React.Fragment>
      <SessionExpiredModal show={sessionExpired} />
      {
        auth.isAuthenticated ? <Outlet /> : null
        // props.children
      }
    </React.Fragment>
  );
}
